import { useUnit } from 'effector-react';
import Map from './Map';
import HexagonsLayer from '../Layers/HexagonsLayer.jsx';
import MetricTree from '../MetricTree/MetricTree.jsx';
import ChartModal from '../ChartModal/ChartModal.jsx';
import MapNavControls from '../MapNavControls/MapNavControls.jsx';
import TimeSlider from '../TimeSlider/TimeSlider.jsx';
import MapGradient from '../MapGradient/MapGradient.jsx';
import FloodsLayer from '../Layers/FloodsLayer.jsx';
import MudfloodsLayer from '../Layers/MudfloodsLayer.jsx';
import MetricModal from '../MetricModal/MetricModal.jsx';
import ChatModal from '../ChatModal/ChatModal.jsx';
import { $userInfo } from '../../models/authModel/index.js';

function MapBlock() {
  const userInfo = useUnit($userInfo);

  const widgets = (
    <>
      <MetricTree />
      <ChartModal />
      <HexagonsLayer />
      <MapNavControls />
      {/* <TimeSlider /> */}
      <MapGradient />
      <FloodsLayer />
      <MudfloodsLayer />
      <MetricModal />
      {userInfo?.perms?.length === 0 && <ChatModal />}
    </>
  );
  return (
    <>
      <Map />
      {widgets}
    </>
  );
}

export default MapBlock;
